export default "assets/images/cru-bourgeois-7f8642ba.png";